export default __webpack_public_path__ + "static/media/build-access-active.4465b031.png";